import { render, staticRenderFns } from "./SimpleUserSelect.vue?vue&type=template&id=364be2a8&"
import script from "./SimpleUserSelect.vue?vue&type=script&lang=ts&"
export * from "./SimpleUserSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports